import React, { Component }  from 'react';
import compose from 'recompose/compose';
import {translate} from 'react-admin';

class DownloadBarcodeField extends Component {

    render() {
        const { record } = this.props;
        const barcodes = typeof record.barcode === "string" ? record.barcode.split(",") : '';
        const items = [];

        if(barcodes !== "") {
            for (const value of barcodes) {
                items.push(<li><a href={value.replace("s3.amazonaws.com", "s3.us-east-2.amazonaws.com")} target="_blank" rel="noopener noreferrer">{unescape(decodeURI(value).substr(decodeURI(value).lastIndexOf('/') + 1))}</a></li>)
            }           
        }


	    return (
            <ul style={{listStyle: "none", padding: 0}}>
            { items }
            </ul>
	    )
	}
};

DownloadBarcodeField.defaultProps = {
    source: 'barcode',
    addLabel: true,
};

const enhance = compose(
    translate
);

export default enhance(DownloadBarcodeField);